import script from "./IndexView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndexView.vue?vue&type=script&setup=true&lang=ts"

import "./IndexView.vue?vue&type=style&index=0&id=49ebb9b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ebb9b4"]])

export default __exports__